/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deceased_Status_SetInputs */



/**
* | output |
* | --- |
* | "Recorded as deceased" |
*
* @param {Deceased_Status_SetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deceased_status_set = /** @type {((inputs?: Deceased_Status_SetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deceased_Status_SetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistré(e) comme décédé(e)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrado como fallecido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrado como falecido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registrato come deceduto")
	return /** @type {LocalizedString} */ ("Recorded as deceased")
});